import React from 'react';
import {I18n} from "react-i18next";

const withTranslation =  (Component) => {
  class WithTranslation extends React.Component {
    render() {
      return (
        <I18n>
          {
            (t) => (
              <Component {...this.props} t={t}/>
            )
          }
        </I18n>
      );
    }
  }
  return WithTranslation;
};

export default withTranslation



// WEBPACK FOOTER //
// src/hoc/withTranslation.js